// extracted by mini-css-extract-plugin
module.exports = {"header":"ActivitiesView_header__nJ0kf","pagination":"ActivitiesView_pagination__1dVhJ","tile":"ActivitiesView_tile__3vT49"};